import React from "react";
import { useNav } from "../customHooks/useNav";
import "./Page.css";

const skillsList = [
  "python",
  "django",
  "graphql",
  "azure",
  "postgresql",
  "mysql",
  "docker",
  "kubernetes",
  "git",
  "linux",
  "html5",
  "css3",
];

const skillLabels = {
  python: "Python",
  django: "Django",
  graphql: "GraphQL",
  azure: "Azure",
  postgresql: "PostgreSQL",
  mysql: "MySQL",
  docker: "Docker",
  kubernetes: "Kubernetes",
  git: "Git",
  linux: "Linux",
  html5: "HTML",
  css3: "CSS",
};

const Skills = () => {
  const skillsRef = useNav("Vaardigheden");

  return (
    <section ref={skillsRef} id="skillsContainer">
      <div className="section-inner skills-grid">
        <div>
          <div className="numbered-label">02</div>
          <h2 className="about-heading">Vaardigheden</h2>
          <p className="skills-intro">
            Hieronder staan de vaardigheden die ik tijdens mijn opleidingen en
            tijdens mijn werk heb ontwikkeld.
          </p>
        </div>
        <div className="skills-pills">
          {skillsList.map((skill) => (
            <div className="skill-pill" key={skill}>
              <i className={`devicon devicon-${skill}-plain`}></i>
              <span>{skillLabels[skill]}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
